import { render, staticRenderFns } from "./PublicationBanner.vue?vue&type=template&id=6270aa6a"
import script from "./PublicationBanner.vue?vue&type=script&lang=js"
export * from "./PublicationBanner.vue?vue&type=script&lang=js"
import style0 from "./PublicationBanner.vue?vue&type=style&index=0&id=6270aa6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports